export default function ButtonAction({label,color,clickEvent}){
    
    return(
        <div className={color=="purple"?"action-button action-button-purple":color=="pink"?"action-button action-button-pink":"action-button"} onClick={clickEvent}>{label}</div>
    )

}